module.exports = __webpack_public_path__ + "media/images/lavo-8ca41504c30460f3ee8cb322b42c907d.jpg";